"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineLabel = exports.Label = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_aria_1 = require("react-aria");
const Css_1 = require("../Css");
/** An internal helper component for rendering form labels. */
exports.Label = react_1.default.memo((props) => {
    const { labelProps, label, hidden, suffix, contrast = false, ...others } = props;
    const labelEl = ((0, jsx_runtime_1.jsxs)("label", { ...labelProps, ...others, css: Css_1.Css.dib.sm.gray700.mbPx(4).if(contrast).white.$, children: [label, suffix && ` ${suffix}`] }));
    return hidden ? (0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: labelEl }) : labelEl;
});
/** Used for showing labels within text fields. */
function InlineLabel({ labelProps, label, contrast, ...others }) {
    return ((0, jsx_runtime_1.jsxs)("label", { ...labelProps, ...others, css: Css_1.Css.smMd.nowrap.gray900.prPx(4).add("color", "currentColor").$, children: [label, ":"] }));
}
exports.InlineLabel = InlineLabel;
